import React, { Component } from 'react';

class NoMatch extends Component {
    render() {
        return (
            <div>
                <h2>Not Found</h2>
            </div>
        );
    }
}

export default NoMatch;
